export var ChatBotRoutes = {
    "careerPortalJobApply": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chat-bot/chat-bot.module.js");
                }
            }
        ],
    },
    "careerStoryTalentPoolApply": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chat-bot/chat-bot.module.js");
                }
            }
        ],
    },
    "/apply/:job_id": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chat-bot/chat-bot.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/harri-main/harri-main.module.js');
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
    },
    "/brand%slug/job/{jobid:[0-9]+}-:title?redirect&view_only&h_apply_flow&first_name&last_name&talent_scout_code_id": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chat-bot/chat-bot.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/harri-main/harri-main.module.js');
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            }
        ],
    },
    "/brand%slug": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/chat-bot/chat-bot.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/harri-main/harri-main.module.js');
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            },
            {path: "@googlemaps/markerclusterer", type: "library", "name": "@googlemaps/markerclusterer"},
        ],
    },
};